<template>
  <div id="app">
    <div class="container-fluid px-0">
      <div style="height: 1em" class="row">
        <div class="col-12">
          <!--<p v-b-modal="'login' + this.uid">Iniciar Sesión</p>-->
        </div>
      </div>
      <div class="row d-flex flex-column align-content-center mx-0 py-3">
        <div class="col-6">
          <div
            v-if="showNav"
            id="nav"
            class="d-flex flex-row justify-content-center"
          >
            <router-link to="/" class="text-dark">Home</router-link>
            <span class="text-warning mx-3">|</span>
            <router-link to="/editar" class="text-dark">Editar</router-link>
            <span class="text-warning mx-3">|</span>
            <router-link to="/detalles" class="text-dark">Zeda</router-link>
            <span class="text-warning mx-3">|</span>
            <router-link to="/buro" class="text-dark">Buró</router-link>
            <span class="text-warning mx-3">|</span>
            <div @click="logout" class="btn btn-danger text-white btn-sm">
              Cerrar sesión
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex flex-column align-content-center mx-0 py-1">
        <div class="col-12 px-0">
          <div>
            <router-view :isOnline="isOnline" />
          </div>
          <!--<div v-else>
            <router-view />
          </div>-->
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <b-modal title="Ingresar como Editor" :id="'login' + this.uid" hide-footer>
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group id="input-group-1" label="Usuario:" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="form.email"
                        type="email"
                        required
                        placeholder="Ingresa tu usuario"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Contraseña:" label-for="input-2">
                      <b-form-input
                        id="input-2"
                        type="password"
                        v-model="form.password"
                        required
                        placeholder="Ingresa tu password"
                      ></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Ingresar</b-button>
                    <b-button type="reset" class="mx-2" variant="danger">Limpiar campos</b-button>
                  </b-form>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
// import bus from './main'
// import EventBus from './components/EventBus'

export default {
  name: 'App',
  data() {
    return {
      showNav: false,
      conexion: true,
      // showcerrar: false,
      showcerrar: false,
      form: {
        email: '',
        password: ''
      },
      show: true,
      isOnline: true,
      localRoot: null,
      id_revista: null,
      validUsers: [
        'danieldev@gmail.com',
        'pale@gmail.com',
        'lsalmones@zedacomunicacion.com.mx',
        'acuadros@zedacomunicacion.com.mx',
        'daniel@gmail.com',
        'valeriap@ciencias.unam.mx'
      ]
    }
  },

  created() {
    //* Get the current URL
    let splittedURL = window.location.href.split('/')
    this.id_revista = splittedURL[splittedURL.length - 2]

    if (this.id_revista === '133') {
      let currentMes = '07'
      window.localStorage.setItem('revistaNum', currentMes)
    } else if (this.id_revista === '134') {
      let currentMes = '08'
      window.localStorage.setItem('revistaNum', currentMes)
    } else {
      let currentMes = null
      window.localStorage.setItem('revistaNum', currentMes)
    }

    if (firebase.auth().currentUser) {
      this.validUsers.forEach(element => {
        if (element == firebase.auth().currentUser.email) {
          this.showNav = true
        }
      })
      if (!this.showNav == true) {
        this.$router.replace('Home')
      }
    } else {
      axios
        .post('conecta_buro.php')
        .then(resp => {
          if (resp.data === 1) {
            axios
              .post('get_root.php', { id_revista: this.id_revista })
              .then(resp => {
                this.showNav = false
                this.isOnline = false
                window.localStorage.setItem('root', JSON.stringify(resp.data))
              })
          }
        })
        .catch(Error => {
          console.log(Error)
        })
    }

    // console.log('Current-user, app: ' + firebase.auth().onAuthStateChanged)

    // firebase.auth().onAuthStateChanged(user => {
    //   if (user) {
    //     this.showcerrar = true
    //     this.showNav = true
    //   } else {
    //     return
    //   }
    // })

    // if (firebase.auth().currentUser) {
    //   // this.$router.replace('editar')
    // } else {
    //   this.showcerrar = false
    // }

    // EventBus.$on('CHECK_LOGIN', isLogin => {
    //   this.updateLogin(isLogin)
    // })

    /*firebase
        .auth()
        .signInWithEmailAndPassword("pale@gmail.com", "palemona")
        .then(user => {
          this.conexion = true
          console.log(user)
        })
        .catch(() => {
          this.conexion = false
        })*/
    //this.conexion = false
  },

  methods: {
    // updateLogin(isLogin) {
    //   alert(isLogin)
    //   this.showcerrar = isLogin
    //   this.showNav = isLogin
    //   this.$router.replace('/editar')
    //   console.log('inside this')
    // },

    // onSubmit(evt) {
    //   evt.preventDefault()
    //   // this.showNav = !this.showNav
    //   firebase
    //     .auth()
    //     .signInWithEmailAndPassword(this.form.email, this.form.password)
    //     .then(resp => {
    //       console.log(resp)
    //       this.showNav = true
    //       alert(` Bienvenido: ${resp.users[0].email} `)
    //       this.$nextTick(() => {
    //         this.$bvModal.hide('login' + this.uid)
    //         this.conexion = true
    //         this.showNav = true
    //       })
    //     })
    //     .catch(() => {
    //       alert('No existe el usuario')
    //     })
    // },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.user = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          //this.showNav = false
          this.showcerrar = false
          this.showNav = false
          alert('sesion cerrada')
          this.$router.replace('/login')
          //this.conexion = false
        })
        .catch(Error => {
          alert(Error)
        })
    }
  }
}
</script>

<style lang="scss">
#app {
  background-color: aliceblue;
  height: 100%;
}

body {
  display: grid;
  grid:
    'header'
    'main'
    'footer';
}

.clic {
  cursor: pointer;
}

/*BUTTONS*/
.btn-edit {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  margin: 10px !important;
  z-index: 10;
}

.btn-agregar-seccion {
  color: #b5b5b5 !important;
}

.btns-menu button {
  margin: 5px;
}
</style>
